import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { PartiallyDeliveredReasonsList } from './partially-delivered-reasons-list/partially-delivered-reasons-list';


@Component({
  selector: 'app-partially-delivered-reasons',
  standalone: true,
  imports: [
    RouterLink,
    PartiallyDeliveredReasonsList,
    RouterOutlet
  ],
  templateUrl: './partially-delivered-reasons.html',
  styleUrl: './partially-delivered-reasons.scss',
})
export class PartiallyDeliveredReasons {}